import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import MessageGrid from '../purchaseRequisition/messageGrid';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthorizationPurchaseReturn from './authorisation';
import ItemGridPurchaseReturn from './itemGrid';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import { FaSave } from 'react-icons/fa';
import { RiRefreshLine } from 'react-icons/ri';
import { FaAngleLeft } from 'react-icons/fa6';
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import Attachment from '../Attachment/attachment';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: '',
  remarks: '',
});
const CreatePurchaseReturn = () => {
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false]);
  const apiService = new ApiService();
  const { currencyPrecision } = useCurrency();
  const [ItemData, setItemData] = useState([]);
  const [POData, setPOData] = useState([]);
  const [usersDetails, setUser] = useState([]);
  const [SelectedWareHouse, setSelectedWareHouse] = useState([]);
  const [PurchaseOrder, setPurchaseOrder] = useState([]);
  const [grnSearch, setGrnSearch] = useState('');
  const [SelectedPO, setSelectedPO] = useState([]);
  const [SelectedGrn, setSelectedGrn] = useState();
  const [SelectedSupplier, setSelectedSupplier] = useState([]);
  const [SelectedSupplierId, setSelectedSupplierID] = useState([]);
  const [SelectedCurrency, setSelectedCurency] = useState([]);
  const [ReturnNo, setReturnNo] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [SupplierTab, setSupplierTab] = useState(false);
  const [PurchaseTab, setPurchaseTab] = useState(true);
  const userId = useSelector(getUserId);
  const userName = useSelector(getUserName);
  const Company = useSelector(getCompany);
  const [loader, setLoader] = useState(false);
  const item = location.state;


  // Attachment
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const [docModal, setDocModal] = useState(false);
  const onOpenModal = () => setDocModal(true);
  const onCloseModal = () => setDocModal(false);
  const openModal = () => setAttachmentModal(true);
  const closeModal = () => setAttachmentModal(false);
  const isReadOnly = item?.eye === true;


  const formatDateToDatetimeLocal = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const getCurrentLocalDatetime = () => {
    const localDate = new Date();
    const offset = localDate.getTimezoneOffset() * 60000;
    const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
    return localISOTime;
  };
  useEffect(() => {
    fetchData();
    getApprovalUser();
    getCurrency();
  }, []);
  const fetchData = async () => {
    let param = `?dropdownTypes=GrnNosPurchaseReturn`
    const response = await apiService.getApiParamater('GET_DIRECT_PO', param);
    let data = response?.data?.dropdowns?.GrnNosPurchaseReturn || []
    setPurchaseOrder(data);
  };
  const getApprovalUser = async () => {
    try {
      const apiService = new ApiService();
      let docParam = `?TypeOfDoc=PR&DocId=PR`;
      let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam);
      setReturnNo(DocId?.data.result[0].docId);
      if (location.state) {
        const params = new URLSearchParams();
        params.append('DocNo', item?.prNo);
        params.append('DocumentType', 'PR');
        const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
        setUser(response.data.result);
      } else {
        const params = new URLSearchParams();
        params.append('DocNo', '');
        params.append('DocumentType', 'PR');
        const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
        setUser(response.data.result);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const GenerateNumber = async () => {
    let docParam = `?TypeOfDoc=PR&DocId=PR`;
    const DocId = await apiService.getApiParamater('GET_DOC_ID', docParam);
    setReturnNo(DocId?.data.result[0].docId);
    onCloseModal();
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleMessage = (data) => {
    // setMessageData(data);
    console.log(data, 'reqData');
  };
  const handleRequisitionData = (data) => {
    setItemData(data);
    console.log(data, 'reqData');
  };
  const handleAuthorization = (data) => {
    // setAuthorizationData(data);
    console.log(data, 'reqData');
  };
  const [formData, setFormData] = useState({
    PRNo: '',
    prNo: '',
    grnStatus: '',
    remarks: '',
    InvoiceNo: '',
    refNo: '',
    InvoiceDate: getCurrentLocalDatetime(),
    deliveryDate: getCurrentLocalDatetime(),
    pOrderNo: '',
    TaxInvoice: '',
    Property: '',
    Department: '',
    Outlet: '',
    Currency: '',
    exchangeRate: '',
    deliveryPoint: '',
    PurchaseOrderDate: getCurrentLocalDatetime(),
    contactPerson: '',
    contatNo: '',
    taskCode: '',
    email: '',
    subcatname: '',
    location: '',
  });
  // Search across all loaded GRNs but render only the first 100 matches for better performance.
  const grnOptions = PurchaseOrder
    .filter((grn) => String(grn?.text || grn?.value || '').toLowerCase().includes(grnSearch.toLowerCase()))
    .slice(0, 100)
    .map((grn) => ({ value: grn, label: grn?.text || grn?.value || '' }));

  const handleGrnInputChange = (inputValue, actionMeta) => {
    if (actionMeta.action === 'input-change') setGrnSearch(inputValue);
    return inputValue;
  };

  const handlePoChange = async (selectedOption) => {

    const params = new URLSearchParams();
    params.append('Id', selectedOption?.label || '');
    const res = await apiService.getApiParamater('GET_GRN', `?${params.toString()}`);
    const selectedGRN = res?.data?.result[0];
    setSelectedPO(res?.data?.result?.map((po) => ({ value: po, label: po?.grnNo }))[0]);
    setSelectedSupplier({ label: selectedGRN.vendorName, value: selectedGRN });
    setSelectedSupplierID({ label: selectedGRN.vendorId, value: selectedGRN });
    setSelectedGrn(selectedGRN?.pOrderNo);
    setFormData({ ...formData, PurchaseOrderDate: formatDateToDatetimeLocal(selectedGRN.modifiedOn) });
    setSelectedWareHouse({ label: selectedGRN.warehouse, value: selectedGRN?.warehouse });
    // setPOData(selectedOption.value.grnDetails)
    fetchGRNData(selectedOption);
  };
  const fetchGRNData = async (selectedOption) => {
    let param = `?GRNNo=${selectedOption?.label}`;
    const PO = await apiService.getApiParamater('GET_GRN_P_RETURN', param);
    if (PO?.data?.message === 'Record not found') {
      setPOData([]);
      toast?.warning('No Items To Return');
    } else {
      setPOData(PO.data.result);
    }
  };
  const handleLocationChange = (selectedOption) => {
    setSelectedWareHouse(selectedOption);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'PurchaseOrderDate' || name === 'deliveryDate') {
      const dateParts = e.target.value.split('-');
      if (dateParts[0].length > 4) {
        return;
      }
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const CreatePR = async () => {
    setLoader(true);
    if (ItemData.length === 0) {
      toast.warning('Please add items');
      setLoader(false);
      return;
    }
    if (!SelectedWareHouse) {
      toast.warning('Select Location');
      setLoader(false);
      return;
    }
    const hasBaseQty = ItemData.some((item) => item.qty > 0);
    if (!hasBaseQty) {
      toast.warning('At least one item must have a base quantity greater than zero.');
      setLoader(false);
      return;
    }
    for (const item of ItemData) {
      if (!item.itemDescription) {
        toast.warning(`Please Select Item`);
        setLoader(false);
        return;
      } else if (item.stockloc === 0) {
        toast.warning(`${item?.itemDescription} Stock not available in this location`);
        setLoader(false);
        return;
      }
    }
    try {
      const currentDatetimeUTC = new Date().toISOString();
      const apiService = new ApiService();
      const totalAmount = ItemData.reduce((sum, row) => sum + (row?.amount || 0), 0);
      const purchaseReturnDetailDtos = ItemData.map((item, index) => ({
        budgetCode: '',
        batchNo: '',
        expDate: formData?.deliveryDate,
        srno: item?.srno,
        itemCode: item?.ItemNo,
        itemDescription: item.itemDescription,
        uom: item.uom,
        qty: parseInt(item.qty || '0'),
        baseUOM: item?.uom,
        baseQty: parseInt(item.balqty),
        specification: item.specification,
        convValue: parseInt(item?.baseQty),
        unitPrice: Number(item.unitPrice).toFixed(SelectedCurrency?.value?.precision || 2),
        amount: Number(item.amount).toFixed(SelectedCurrency?.value?.precision || 2),
        baseAmount: Number(item.amount).toFixed(SelectedCurrency?.value?.precision || 2),
        vatAmount: Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 2),
        convToInvUOM: parseFloat(item.conValue),
        vatPerc: parseFloat(item.vat) || 0,
        vatDesc: item?.vatDesc || '',
        vatUnitPrice: parseFloat(Number(item.vatAmount / item.qty).toFixed(SelectedCurrency?.value?.precision || 2)) || 0.0,
        vatBaseAmount: Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 2) || 0.0,
        prodDate: currentDatetimeUTC,
        isActive: true,
        psrno: index + 1,
        expDate: item.expDate,
        grnDetailId: item.grnDetailId,
      }));
      const userData = {
        prNo: ReturnNo,
        grnNo: SelectedPO?.value.grnNo,
        status: 0,
        invoiceRef: formData.refNo,
        pOrderNo: SelectedGrn,
        delivery_Date: formData?.deliveryDate,
        vendorId: SelectedSupplierId.label,
        vendorName: SelectedSupplier?.label,
        remarks: formData?.remarks,
        isActive: true,
        purchaseReturnDetailDtos: purchaseReturnDetailDtos,
        invoiceNo: formData.InvoiceNo,
        invoiceDate: SelectedPO?.value.InvoiceDate,
        currencyCode: SelectedCurrency.label,
        exchangeRate: SelectedCurrency?.value.conversionRate,
        baseAmount: Number(totalAmount).toFixed(SelectedCurrency?.value?.precision || 2),
        amount: Number(totalAmount).toFixed(SelectedCurrency?.value?.precision || 2),
        modifiedBy: userName,
        warehouse: SelectedWareHouse.label,
      };

      const response = await apiService.post('CREATE_P_RETURN', userData);
      if (response?.data?.statusCode === 201) {
        const userData2 = {
          docType: 'PR',
          docId: ReturnNo,
          department: 'IT',
          company: Company?.selectedCompany?.companyNo,
          userCode: userId,
          userName: userName,
        };
        const docBody = {
          docId: 'PR',
          typeOfDoc: 'PR',
        };
        const docRes = await apiService.put('UPDATE_DOC_ID', docBody);

        if (attachments) {
          handleUpload();
        }
        const response2 = await apiService.post('CREATE_DOC_AUTHORIZATION', userData2);
        const paramsGet = new URLSearchParams();
        paramsGet.append('docType', 'PR');
        paramsGet.append('docId', ReturnNo);
        paramsGet.append('srno', 1);
        const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
        // if (response3?.data?.result.length > 0) {
        //   const toEmails = response3?.data?.result?.map((user) => user.userEmail);
        //   const emailbody = {
        //     toEmails: toEmails,
        //     subject: 'Purchase Return',
        //     body: '',
        //     docNo: ReturnNo,
        //     srNo: 1,
        //     docType: 'PR',
        //   };
        //   const emailres = await apiService.post('DOC_APPROVAL_EMAIL_POST', emailbody);
        // }
        const token = localStorage.getItem('Token');
        const DB = localStorage.getItem('DataBase');
        if (!token) {
          alert('Auth token is missing! Unable to proceed.');
          return;
        }
        const popupWidth = 1000;
        const popupHeight = 600;
        const popupLeft = (window.screen.width - popupWidth) / 2;
        const popupTop = (window.screen.height - popupHeight) / 2;
        const popup = window.open(
          '',
          'ReportPopup',
          `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
        );

        if (popup) {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = REPORT_URL;
          form.target = 'ReportPopup';

          const inputs = [
            { name: 'authToken', value: token },
            { name: '_db', value: DB },
            { name: 'reportName', value: 'PurchaseReturn' },
            { name: 'voucherNo', value: ReturnNo },
          ];

          inputs.forEach(({ name, value }) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
          });

          document.body.appendChild(form);
          form.submit();
          document.body.removeChild(form);
        }
        toast.success(`${ReturnNo} Created successfully`);
        setLoader(false);
        navigate('/inventory/PurchaseReturn/List');
      } else if (response?.data?.statusCode === 208) {
        setLoader(false);
        onOpenModal();
      } else {
        setLoader(false);
        toast.error(response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error('Error Creating PR:', error);
    }
  };
  const UpdatePR = async () => {
    setLoader(true);
    if (ItemData.length === 0) {
      toast.warning('Please add items');
      setLoader(false);
      return;
    }
    try {
      const currentDatetimeUTC = new Date().toISOString();
      const apiService = new ApiService();
      const totalAmount = ItemData.reduce((sum, row) => sum + (row?.qty * row.unitPrice || 0), 0);
      const baseAmount = ItemData.reduce((sum, row) => sum + (row?.balqty * row.unitPrice || 0), 0);
      const extractPO = (requisitionNo) => {
        return requisitionNo.replace('PO-24-', '').replace(/^0+/, '');
      };
      let cleanedRequisitionNo = extractPO(SelectedGrn);
      const purchaseReturnDetailDtos = ItemData.map((item, index) => ({
        budgetCode: 'string',
        batchNo: 'string',
        expDate: formData?.deliveryDate,
        srno: index + 1,
        itemCode: item?.ItemNo,
        itemDescription: item?.itemDescription,
        uom: item.uom,
        qty: parseInt(item.qty || '0'),
        baseUOM: item?.uom,
        baseQty: parseInt(item.balqty),
        specification: item.specification,
        convValue: parseInt(item?.baseQty),
        unitPrice: parseInt(item.unitPrice),
        amount: parseInt(item.qty * item.unitPrice),
        baseAmount: parseInt(item.balqty * item.unitPrice),
        convToInvUOM: parseInt(item.baseQty),
        prodDate: currentDatetimeUTC,
        isActive: true,
      }));

      const userData = {
        prNo: formData.prNo,
        grnNo: SelectedPO?.value.recordId.toString(),
        invoiceRef: formData.InvoiceNo,
        pOrderNo: cleanedRequisitionNo,
        delivery_Date: formData?.deliveryDate,
        vendorId: SelectedSupplierId.label,
        vendorName: SelectedSupplier?.label,
        baseAmount: baseAmount,
        remarks: formData?.remarks,
        isActive: true,
        purchaseReturnDetailDtos: purchaseReturnDetailDtos,
        invoiceNo: formData.InvoiceNo,
        invoiceDate: SelectedPO?.value.InvoiceDate,
        currencyCode: SelectedCurrency.label,
        exchangeRate: SelectedCurrency?.value.conversionRate,
        amount: totalAmount,
        warehouse: formData.location,
      };

      const response = await apiService.put('UPDATE_P_RETURN', userData);
      if (response?.data?.statusCode === 201) {
        const userData2 = {
          docType: 'PR',
          docId: ReturnNo,
          status: 0,
          remarks: formData?.remarks,
        };
        const response2 = await apiService.put('UPDATE_DOC_AUTHORIZATION_STATUS', userData2);
        if (response?.data?.statusCode === 201) {
          const paramsGet = new URLSearchParams();
          paramsGet.append('docType', 'PR');
          paramsGet.append('docId', ReturnNo);
          paramsGet.append('srno', 1);
          const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
          // if (response3?.data?.result.length > 0) {
          //   const toEmails = response3?.data?.result?.map((user) => user.userEmail);
          //   const emailbody = {
          //     toEmails: toEmails,
          //     subject: 'Purchase Return',
          //     body: '',
          //     docNo: ReturnNo,
          //     srNo: 1,
          //     docType: 'PR',
          //   };
          //   const emailres = await apiService.post('DOC_APPROVAL_EMAIL_POST', emailbody);
          // }
          navigate('/inventory/PurchaseReturn/List');
          setLoader(false);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error('Error Creating PR:', error);
    }
  };
  const getCurrency = async () => {

    const currencylist = JSON.parse(localStorage.getItem('currencylist')) || [];
    const newDefaultCurrency = currencylist?.find((comp) => comp.isDefault === true);
    setSelectedCurency({ label: newDefaultCurrency.code, value: newDefaultCurrency });
    setFormData({ ...formData, exchangeRate: newDefaultCurrency.conversionRate });
  };
  const handleBackClick = () => {
    window.history.back();
  };

  // Attachment Functions
  const handleFileSelect = useCallback((file, id) => {
    setAttachments((prev) => {
      const updated = prev.map((row) => (row.id === id ? { ...row, file, fileName: file.name } : row));
      return [...updated, createEmptyRow()];
    });
  }, []);
  const handleRemarkChange = (id, value) => {
    setAttachments((prev) => prev.map((row) => (row.id === id ? { ...row, remarks: value } : row)));
  };
  const handleDelete = (id) => {
    setAttachments((prev) => prev.filter((row) => row.id !== id));
  };
  const handleUpload = async () => {
    const formData = new FormData();

    attachments.forEach(({ file }) => {
      if (file instanceof File) {
        formData.append('Images', file, file.name);
      }
    });

    const response = await apiService.postMultiPart('UPLOAD_FILE', formData);

    if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
      const uploadedFileNames = response.data.result.split(',');

      const payload = {
        docFilesDtos: attachments
          .filter((a) => a.file)
          .map((a, index) => ({
            srno: index + 1,
            docNo: ReturnNo,
            docType: 'PReturn',
            fileName: uploadedFileNames[index]?.trim(),
            remarks: a.remarks || '',
          })),
      };

      await apiService.post('CREATE_ATTACHMENT', payload);
      return;
    }
  };
  return (
    <div className="px-4 pt-3">
      <div className="d-flex justify-contant-between ">
        <h5 className="col mainInvHead">Purchase Return</h5>
        <div className="d-flex justify-content-end gap-1">
          <div>
            {location.state ? (
              <>
                {loader === true ? (
                  <button className="mainbtn " type="submit">
                    <ClipLoader color="#ffffff" size={25} />
                  </button>
                ) : (
                  <>
                    {item?.eye === true ? (
                      ''
                    ) : (
                      <button className="mainbtn " type="submit" onClick={UpdatePR}>
                        <FaSave className="center mt-1 mx-2" />
                        <div>Update</div>
                      </button>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {loader === true ? (
                  <button className="mainbtn " type="submit">
                    <ClipLoader color="#ffffff" size={25} />
                  </button>
                ) : (
                  <>
                    {item?.eye === true ? (
                      ''
                    ) : (
                      <button className="mainbtn " type="submit" onClick={CreatePR}>
                        <FaSave className="center mt-1 mx-2" />
                        <div>Save</div>
                      </button>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          {item?.eye === true ? (
            ''
          ) : (
            <button className="mainbtnRed">
              <RiRefreshLine className="center mt-1 mx-2" />
              <div>Reset</div>
            </button>
          )}
          <button onClick={handleBackClick} className="mainbtnSecondary">
            <FaAngleLeft className="center mt-1 mx-2" />
            <div>Back</div>
          </button>
        </div>
      </div>
      <div className="cost-center-section mb-2">
        <div className="d-flex mt-3 cursor-pointer slide-header gap-4" onClick={() => setPurchaseTab(!PurchaseTab)}>
          <div className="h6 pt-1">GRN Details</div>
        </div>
        <div className={`slide-content ${PurchaseTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group justify-content-between row pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="ReturnNo" className="form-label  pt-1 start">
                  Purchase Return No
                </label>
                <input className="form-Input w-100" value={ReturnNo} name="ReturnNo" disabled />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="catcode" className="form-label  pt-1 start">
                  Date{' '}
                </label>
                <input
                  className="form-Input w-100"
                  type="datetime-local"
                  name="deliveryDate"
                  disabled={item?.eye === true ? true : false}
                  value={formData.deliveryDate}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">
                  Location
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  isDisabled
                  value={SelectedWareHouse}
                  onChange={handleLocationChange}
                />
              </div>
            </div>
            <div className="form-group row justify-content-between pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">
                  GRN No *
                </label>
                <Select
                  isDisabled={item?.eye === true ? true : false}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  value={SelectedPO}
                  options={grnOptions}
                  inputValue={grnSearch}
                  onInputChange={handleGrnInputChange}
                  filterOption={null}
                  onChange={(selectedOption) => { setGrnSearch(''); handlePoChange(selectedOption); }}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="InvoiceNo" className="form-label  pt-1 start">
                  Invoice Reg No
                </label>
                <input
                  type="number"
                  disabled={item?.eye === true ? true : false}
                  className="form-Input w-100"
                  id="InvoiceNo"
                  value={formData.InvoiceNo}
                  onChange={handleInputChange}
                  name="InvoiceNo"
                  onWheel={(e) => e.target.blur()}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="InvoiceDate" className="form-label  pt-1 start">
                  Ref NO
                </label>
                <input
                  type="number"
                  disabled={item?.eye === true ? true : false}
                  className="form-Input w-100"
                  id="refNo"
                  value={formData.refNo}
                  onChange={handleInputChange}
                  name="refNo"
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="form-group row justify-content-between pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">
                  GRN Date
                </label>
                <input
                  //   disabled={item?.eye === true ? true : false}
                  disabled
                  type="datetime-local"
                  className="form-Input w-100"
                  id="PurchaseOrderDate"
                  value={formData.PurchaseOrderDate}
                  onChange={handleInputChange}
                  name="PurchaseOrderDate"
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="pOrderNo" className="form-label  pt-1 start">
                  POrder No
                </label>
                <input
                  disabled={item?.eye === true ? true : false}
                  type="text"
                  className="form-Input w-100"
                  id="pOrderNo"
                  value={SelectedGrn}
                  name="pOrderNo"
                  readOnly
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="remarks" className="form-label  pt-1 start">
                  Remarks
                </label>
                <input
                  disabled={item?.eye === true ? true : false}
                  name="remarks"
                  type="text"
                  className="form-Input w-100"
                  id="remarks"
                  value={formData.remarks}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cost-center-section mb-2">
        <div className="d-flex mt-3 cursor-pointer slide-header gap-4" onClick={() => setSupplierTab(!SupplierTab)}>
          <div className="h6 pt-1">Supplier Details</div>
        </div>
        <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group row justify-content-between pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="PropertyGroup" className="form-label  pt-1 start">
                  Supplier
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  isDisabled
                  value={SelectedSupplier}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">
                  Supplier ID
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  isDisabled
                  value={SelectedSupplierId}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="Property" className="form-label  pt-1 start">
                  Currency
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-100 p-0"
                  isDisabled
                  value={SelectedCurrency}
                />
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="col-4 d-flex justify-content-between">
                <label htmlFor="EXRate" className="form-label  pt-1 start">
                  EX Rate
                </label>
                <input
                  type="number"
                  className="form-Input w-100"
                  disabled
                  onWheel={(e) => e.target.blur()}
                  id="exchangeRate"
                  value={formData.exchangeRate}
                  onChange={handleInputChange}
                  name="exchangeRate"
                />
              </div>
              <div className="col-1 px-5 mx-3"></div>
              <div className="col-2 brderbox center" onClick={() => openModal()}>
                {'Attachment'}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`cost-center-section`}>
        <div className="mt-3 cursor-pointer slide-header">
          <div className="nav nav-pills overslid d-flex gap-4">
            {/* Nav tabs */}
            <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
              Items
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
              Authorization
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
              Message
            </div>
          </div>
        </div>
      </div>
      <div className={`slide-content open`}>
        <div className={`grid-1 border-box2 p-3`}>
          {gridVisibility[0] && (
            <ItemGridPurchaseReturn
              onRequisitionData={handleRequisitionData}
              GrnItemData={POData}
              item={item}
              SelectedPO={SelectedPO}
              currencyPrecision={currencyPrecision?.exp3 || 3}
            />
          )}
          {gridVisibility[1] && (
            <AuthorizationPurchaseReturn handleAuthorization={handleAuthorization} usersDetails={usersDetails} setUser={setUser} itemData={POData} />
          )}
          {gridVisibility[2] && (
            <div className="grid-3 border">
              <MessageGrid handleMessage={handleMessage} />
            </div>
          )}
        </div>
      </div>
      <Attachment
        documentNo={ReturnNo}
        open={attachmentModal}
        onClose={closeModal}
        rows={attachments}
        readOnly={isReadOnly}
        onFileSelect={handleFileSelect}
        onRemarkChange={handleRemarkChange}
        onDelete={handleDelete}
        onSave={handleUpload}
      />
      <Modal size="md" show={docModal} onHide={() => setDocModal(false)} backdrop="static" contentLabel="Doc Id Modal">
        <Modal.Header closeButton>
          <Modal.Title className="center">Purchase Return Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-danger">The Purchase Return number already exists. Click "Generate" to assign a new number.</p>
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button className="mainbtnGry" onClick={onCloseModal}>
            Cancel
          </button>
          <button className="mainbtnRed" onClick={GenerateNumber}>
            Generate
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreatePurchaseReturn;
